export enum SwitchToggleValues {
  NotUsingTools = '0',
  UsingTools = '1',
  Autopilot = '2',
  DirectControl = '3',
}

export enum PhasrPanelComponentTypes {
  BehavioralProfiles = 'behavioralProfiles',
  BehavioralProfilesNoToggle = 'behavioralProfilesNoToggle',
  RestrictedBehavioralProfiles = 'restrictedBehavioralProfiles',
  RuleTriggers = 'ruleTriggers',
  MonitoredRulesDetails = 'monitoredRulesDetails',
}

export enum PhasrSidePanelEvents {
  ViewSet = 'viewSet',
  EditAccess = 'editAccess',
}

export const PAGE_LIMIT = 25;

export const SEVERITY_COLORS = {
  'highSeverity': '#E23636',
  'mediumSeverity': '#FF9900',
  'lowSeverity': '#D2A40D',
}

export interface RuleTrigger {
  alertId: string,
  alertName: string,
  alertCreatedDate: Date,
  severity: number,
  incidentId: string,
  incidentNumber: number,
  userName: string,
  hostName: string,
}

export interface RuleTriggerSpecific {
  ruleId: string
}

export interface BehavioralProfileSpecific {
  recommendationId: string,
  ruleId: number,
  ruleTriggers: number,
  phasrUsable?: boolean,
}

export interface PhasrSidePanelViewData {
  titleText: string;
  componentType: string;
  hasBackButton: boolean;
}

export interface GetBehavioralProfilesPayload {
  page: number;
  limit: number;
  companyId: string;
  filter: Array<Filter>;
}

interface Filter {
  property: string;
  value: any;
}

export interface GetBehavioralProfilesResponse {
  behavioralProfileIdentity: string;
  behavioralProfileIdentityName: string;
  behavioralProfileResource: string;
  behavioralProfileResourceName: string;
  userSid: string;
}
